const companyUpdateOutstandingBalanceAccess = auth =>
  auth.access.specialPermissions.payments.updateCompanyOutstandingBalance;

export { companyUpdateOutstandingBalanceAccess };
